import React from "react";
import { BookOpenIcon } from "lucide-react";
import { images } from "../../data/content";
import { CTAButton } from "../CTAButton";
import { OfferUrgency } from "../OfferUrgency";
export function Hero() {
  return <header className="bg-cream px-4 pb-14 pt-8 sm:pt-12" data-id="element-172" data-mp="cutdm7puk59m">
      <div className="mx-auto max-w-4xl text-center" data-id="element-173" data-mp="huxpfkft8bti">
        <div className="flex items-center justify-center gap-2" data-id="element-174" data-mp="hwilxfloq4u0">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-ink text-goldsoft" data-id="element-175" data-mp="mutyhy3d6tfx">
            <BookOpenIcon className="h-5 w-5" aria-hidden data-id="element-176" data-mp="quua7az2wqja" />
          </span>
          <span className="font-serif text-lg font-bold text-ink" data-id="element-177" data-mp="vmm49vhg1ee6">Lipo Revision Case Atlas™</span>
        </div>

        <p className="mx-auto mt-6 inline-block rounded-full bg-ink px-4 py-2 text-[12px] font-bold uppercase tracking-wider text-goldsoft" data-id="element-178" data-mp="10lyos9kue9dl">
          For plastic surgeons & aesthetic physicians
        </p>

        <h1 className="mt-5 font-serif text-[36px] font-bold leading-[1.08] text-ink sm:text-6xl" data-id="element-179" data-mp="1aitouwwrkhtz">
          Structure and Review a Liposuction Revision Case in{" "}
          <em className="text-gold" data-id="element-180" data-mp="4opsy808q36r">15 Minutes</em>
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-[17px] leading-relaxed text-muted sm:text-lg" data-id="element-181" data-mp="4n51ir9830d4">
          A structured professional case-review system to organize what happened, identify what deserves further
          investigation, clarify unanswered questions, compare the original goal with the current situation, and
          document what you can learn. Includes <strong className="text-ink" data-id="element-182" data-mp="nexrecszw5gm">6 premium volumes</strong>,{" "}
          <strong className="text-ink" data-id="element-183" data-mp="iohf4w0wupvu">5 professional bonuses</strong> and{" "}
          <strong className="text-ink" data-id="element-184" data-mp="imeezj61ngde">30+ revision-case review tools</strong>.
        </p>

        <img src={images.product} alt="The complete Lipo Revision Case Atlas system: 6 volumes, 5 bonuses and review tools" className="-mx-4 mt-6 block w-[calc(100%+2rem)] max-w-none sm:mx-auto sm:w-full sm:max-w-2xl" data-id="element-185" data-mp="emnhkwm0i1zw" />

        <CTAButton id="hero-cta" className="mt-4" label="I want the Lipo Revision Case Atlas™" sublabel="Instant digital access · One-time payment of $27 · Lifetime access · 7-day guarantee" data-id="element-186" data-mp="30lnoeolvy7s2" />

        <OfferUrgency data-id="element-187" data-mp="2qvuf5u97u4qz" />
      </div>
    </header>;
}